import React from 'react';
import cn from 'classname';
import Row from './row';
import RowMonth from './row-month';

const Table = props => {

	const { intervals, rows, changeSort, sort } = props;
	return (
		<div className='table-container overflow-x-scroll position-relative'>
			<table className="simple-table">
				<thead className="simple-table__head font-roboto-medium sticky-top-0">
					<tr>
						<th className="fixed-col min-width-200 text-center">CREATED_MONTH</th>
						{intervals.map((int, key) =>
							<th
								className={cn({
									'fixed-col min-width-200 sort-header text-center': true,
									'active': sort.name === `${int}-approved-count`,
									[ sort.direction === 'desc' ? 'desc' : 'asc']: sort.name === `${int}-approved-count`
								})}
								key={key}
								onClick={changeSort.bind(null, `${int}-approved-count`)}
							>
								{int}
							</th>
						)}
					</tr>
					<tr>
						<th className="fixed-col min-width-200">
							Total Affiliates: {props.totalAffsCount}
						</th>
						{intervals.map((int, key) =>
							<th
								className='fixed-col min-width-200 dis'
								key={key}
							>
								<div className="display-flex justify-content-between">
									<div className="padding-0-5 width-33-p text-center">Leads</div>
									<div className="padding-0-5 width-33-p text-center">Approve</div>
									<div className="padding-0-5 width-33-p text-center">Margin</div>
								</div>
							</th>
						)}
					</tr>
				</thead>
				<tbody className="simple-table__body">
					{
						rows.map((row, key) => {
							if (!row.utm_value && row.created_month)
								return <RowMonth key={key} row={row} {...props} />;

							return <Row key={key} row={row} {...props} />;
						})
					}
				</tbody>
			</table>
		</div>
	);
};

export default Table;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/marketing-funnel/registration-activity/components/table.js